import MTable from './MTable';

export default MTable;
